<template>
  <a-style-provider
    v-if="enabled"
    hash-priority="high"
    :transformers="legacyStyleTransformers"
  >
    <a-app root-class-name="legacy-style-compat-app">
      <slot />
    </a-app>
  </a-style-provider>
  <slot v-else />
</template>

<script>
import { legacyLogicalPropertiesTransformer } from 'ant-design-vue'
import { ENABLE_LEGACY_STYLE_COMPAT } from '@/config/legacyStyleCompat'

export default {
  name: 'LegacyStyleCompatShell',
  data () {
    return {
      enabled: ENABLE_LEGACY_STYLE_COMPAT,
      legacyStyleTransformers: [legacyLogicalPropertiesTransformer]
    }
  }
}
</script>

<style scoped>
:deep(.legacy-style-compat-app) {
  width: 100%;
  height: 100%;
}
</style>
